import { type FormError, type FormErrorSeverity } from 'models/formError';
import type { AlertSeverity } from 'state/notifications/notification.model';

export function lessAgressiveColorMapper(errorSeverity: FormErrorSeverity): AlertSeverity {
  switch (errorSeverity) {
    case 'Failure':
      return 'danger';
    case 'Error':
      return 'warning';
    case 'Warning':
      return 'info';
  }
}
export function moreAgressiveColorMapper(errorSeverity: FormErrorSeverity): AlertSeverity {
  switch (errorSeverity) {
    case 'Error':
      return 'danger';
    case 'Warning':
      return 'warning';
    default:
      return 'secondary' as never;
  }
}

function toPriority(errorSeverity?: FormErrorSeverity): number {
  switch (errorSeverity) {
    case 'Error':
      return 2;
    case 'Warning':
      return 3;
    case 'Failure':
      return 1;
    default:
      return 0;
  }
}

export function sortValidationErrors<Form, Keys extends string = string, KeysPrefix extends string = string>(
  validationErrors: readonly FormError<Form, Keys, KeysPrefix>[],
) {
  return validationErrors.slice().sort((a, b) => toPriority(a.severity) - toPriority(b.severity));
}
